import React from 'react';

export interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  glow?: boolean;
}

export const Card: React.FC<CardProps> = ({ children, glow = false, className = '', style, ...props }) => {
  return (
    <div
      className={`glass-panel ${glow ? 'glass-panel-glow' : ''} ${className}`}
      style={{ padding: '24px', ...style }}
      {...props}
    >
      {children}
    </div>
  );
};
